import { IInteractionsCount } from "@edgetier/watchtower-types";

/**
 * Calculate a summary value from interaction counts (the maximum, mean etc.).
 * @param interactionsCounts Data from response counting interactions.
 * @param aggregate          A function to summarise the values into one.
 * @returns                  Summary value.
 */
export const aggregateValues = (
    interactionsCounts: IInteractionsCount<string>[] | undefined,
    aggregate: (values: number[]) => number
) => {
    if (Array.isArray(interactionsCounts) && interactionsCounts.length > 0) {
        return aggregate((interactionsCounts ?? []).map(({ count }) => count));
    } else {
        return 0;
    }
};
